import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "@utility/slice";
import { Team } from "@mach-energy/common-teams";

const SLICE = "teams";

interface InitialState {
  teams: Team[];
}

const initialState: InitialState = {
  teams: [],
};

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

export const getTeamsForUser = getFromServer(
  "getTeamsForUser",
  async ({ payload }) => payload,
  async (arg) => arg,
);

export const slice = createSlice({
  name: SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(getTeamsForUser.fulfilled, (state, action) => {
      const teams = action.payload.response;

      state.teams = [...teams];
    }),
});

export default slice.reducer;
